export default __webpack_public_path__ + "static/media/hexo.2814941f.svg";